/* Obiad w Koszu – koszyk, kod rabatowy, zgoda, sticky bar. */
(function () {
  'use strict';
  var C = window.OWK || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var SS = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  function sized(u, w) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function money(c) { c = Math.round(c); return (c % 100 === 0 ? String(c / 100) : (c / 100).toFixed(2).replace('.', ',')) + ' zł'; }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body || {}) })
      .then(function (r) { return r.json().catch(function () { return {}; }); });
  }
  function flash(msg) {
    var el = document.querySelector('.owk-toast');
    if (!el) { el = document.createElement('div'); el.className = 'owk-toast'; el.setAttribute('role', 'alert'); document.body.appendChild(el); }
    el.textContent = msg; el.classList.add('is-on');
    clearTimeout(flash.t); flash.t = setTimeout(function () { el.classList.remove('is-on'); }, 4500);
  }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function promoLive() { return C.deadline && Date.now() < C.deadline; }
  function codeActive() { return promoLive() && SS.get('owk_code') === '1'; }

  /* ---------- odliczanie (prawdziwy termin) ---------- */
  function tick() {
    var left = C.deadline - Date.now();
    if (!(left > 0)) { $$('[data-promo]').forEach(function (el) { el.hidden = true; }); return; }
    var d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60, s = Math.floor(left / 1e3) % 60;
    var t = (d ? d + ' d ' : '') + String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    $$('[data-countdown]').forEach(function (el) { el.textContent = 'zostało ' + t; });
  }

  /* ---------- kod rabatowy ---------- */
  function renderCode() {
    var on = codeActive();
    $$('[data-code-box]').forEach(function (b) {
      b.classList.toggle('is-active', on);
      var btn = $('button', b); if (btn) btn.textContent = on ? 'Aktywny ✓' : 'Aktywuj';
    });
    $$('[data-price-final]').forEach(function (el) {
      var base = parseInt(el.getAttribute('data-price-final'), 10);
      el.textContent = money(on ? Math.round(base * (100 - C.pct) / 100) : base);
    });
  }
  function activateCode() {
    SS.set('owk_code', '1');
    renderCode();
    try { if (navigator.clipboard) navigator.clipboard.writeText(C.code); } catch (e) {}
    fetch('/discount/' + encodeURIComponent(C.code), { credentials: 'same-origin', redirect: 'manual' }).catch(function () {});
    return post('/cart/update.js', { discount: C.code }).then(refresh);
  }

  /* ---------- zgoda ---------- */
  function consentText() { return C.consent || ''; }
  function consentAttrs() {
    var now = new Date();
    var ts;
    try {
      ts = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(now);
    } catch (e) { ts = now.toISOString(); }
    return { 'Zgoda klienta': consentText(), 'Data i godzina zgody (Europe/Warsaw)': ts };
  }
  function consentChecked() { return SS.get('owk_consent') === '1'; }
  function syncConsent() { var on = consentChecked(); $$('[data-consent-input]').forEach(function (i) { i.checked = on; }); renderCheckoutBtn(); }
  function requireConsent(scope) {
    if (consentChecked()) return true;
    var box = scope && scope.querySelector ? scope.querySelector('[data-consent]') : null;
    if (!box) box = $('[data-consent]');
    $$('[data-consent]').forEach(function (b) { b.classList.remove('is-error'); });
    if (box) { void box.offsetWidth; box.classList.add('is-error'); box.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    return false;
  }

  /* ---------- kup teraz (z pominięciem koszyka) ---------- */
  function buyNow(variant, btn) {
    var scope = btn.closest('[data-buybox]') || document;
    if (!requireConsent(scope)) return;
    btn.classList.add('is-loading');
    var body = { attributes: consentAttrs() };
    if (codeActive()) body.discount = C.code;
    post('/cart/clear.js', {})
      .then(function () { return post('/cart/add.js', { items: [{ id: variant, quantity: 1 }] }); })
      .then(function (r) { if (r && r.status && r.status >= 400) throw new Error('add'); return post('/cart/update.js', body); })
      .then(function () { location.href = '/checkout' + (codeActive() ? '?discount=' + encodeURIComponent(C.code) : ''); })
      .catch(function () { btn.classList.remove('is-loading'); refresh(); flash('Nie udało się przejść do płatności. Odśwież stronę i spróbuj ponownie.'); });
  }

  /* ---------- koszyk ---------- */
  var drawer, overlay, cart = null;
  function open() { drawer.classList.add('is-open'); overlay.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; drawer.setAttribute('aria-hidden', 'false'); }
  function close() { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); document.documentElement.style.overflow = ''; drawer.setAttribute('aria-hidden', 'true'); }
  function addToCart(variant, openIt) {
    var failed = false;
    return post('/cart/add.js', { items: [{ id: variant, quantity: 1 }] }).then(function (r) {
      if (r && r.status && r.status >= 400) { failed = true; flash('Nie udało się dodać produktu do koszyka. Odśwież stronę i spróbuj ponownie.'); return; }
      if (codeActive()) return post('/cart/update.js', { discount: C.code });
    }).then(refresh).then(function () { if (openIt !== false && !failed) open(); });
  }
  function setQty(map) { return post('/cart/update.js', { updates: map }).then(refresh); }

  function guard(c) {
    var upd = {}, need = false, paid = 0;
    c.items.forEach(function (it) {
      if (it.quantity > 1) { upd[it.variant_id] = 1; need = true; }
      if (it.variant_id !== C.v.gratis && it.price > 0) paid++;
    });
    var hasPack = c.items.some(function (it) { return it.variant_id === C.v.pelny || it.variant_id === C.v.sredni; });
    var hasGratis = c.items.some(function (it) { return it.variant_id === C.v.gratis; });
    if (hasGratis && (paid === 0 || hasPack)) { upd[C.v.gratis] = 0; need = true; }
    return need ? post('/cart/update.js', { updates: upd }).then(getCart) : Promise.resolve(c);
  }

  function refresh() {
    return getCart().then(guard).then(function (c) { cart = c; render(c); return c; });
  }

  function itemHtml(it) {
    var img = it.image || '';
    var disc = it.original_line_price > it.final_line_price;
    var omni = disc ? '<small>Najniższa cena z 30 dni przed obniżką: ' + money(it.original_price) + '</small>' : '';
    return '<div class="owk-item"><img src="' + (img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '') + '" alt="" width="58" height="82" loading="lazy">' +
      '<div class="n">' + it.product_title + omni + '<button class="rm" data-rm="' + it.variant_id + '">Usuń</button></div>' +
      '<div class="pr">' + (disc ? '<s>' + money(it.original_line_price) + '</s>' : '') + (it.final_line_price === 0 ? 'GRATIS' : money(it.final_line_price)) + '</div></div>';
  }

  function render(c) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; });
    $$('[data-cart-root]').forEach(function (root) { renderInto(c, $('[data-cart-body]', root), $('[data-cart-foot]', root)); });
    renderCheckoutBtn();
  }

  function renderInto(c, body, foot) {
    if (!body || !foot) return;
    if (!c.item_count) {
      body.innerHTML = '<div class="owk-empty"><p><b>Twój koszyk jest pusty.</b><br>Zacznij od bestsellera:</p><img src="' + C.img.pelny + '&width=440" alt="Pakiet pełny Obiad w Koszu"><p>9 e-booków · 315 przepisów · 5 bonusów</p><button class="owk-btn" data-add="' + C.v.pelny + '">Dodaj pakiet pełny – ' + money(C.price.pelny) + '</button></div>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    var vids = c.items.map(function (it) { return it.variant_id; });
    var has = function (v) { return vids.indexOf(v) > -1; };
    var singles = c.items.filter(function (it) { return C.single.indexOf(it.variant_id) > -1; });
    var sumSingles = singles.reduce(function (a, it) { return a + it.original_line_price; }, 0);
    var html = c.items.map(itemHtml).join('');
    // order bump zależny od zawartości
    if (!has(C.v.pelny) && has(C.v.sredni)) {
      html += '<div class="owk-bump">Dobierz pozostałe 5 e-booków (śniadania, lżej, dzieci, desery, święta) i 4 bonusy: <b>zamień na pakiet pełny za +' + money(C.price.pelny - C.price.sredni) + '</b>.<button class="owk-btn" data-swap="pelny">Zamień na pakiet pełny</button></div>';
    } else if (!has(C.v.pelny) && singles.length) {
      var diff = C.price.pelny - sumSingles;
      html += '<div class="owk-bump">' + (diff > 0
        ? 'Dopłać <b>' + money(diff) + '</b> i weź wszystkie 9 e-booków (315 przepisów + 5 bonusów) zamiast ' + (singles.length === 1 ? 'jednego' : singles.length + ' wybranych') + '.'
        : 'W pakiecie taniej: <b>wszystkie 9 e-booków za ' + money(C.price.pelny) + '</b> – oszczędzasz ' + money(-diff) + '.') +
        '<button class="owk-btn" data-swap="pelny">Biorę pakiet pełny</button></div>';
    }
    if (has(C.v.pelny) && !has(C.v.prezent)) {
      html += '<label class="owk-check"><input type="checkbox" data-toggle="prezent"><img src="' + C.img.karta + '&width=80" alt="">Dodaj kopię pakietu na prezent + kartę do druku – ' + money(C.price.prezent) + '</label>';
    }
    if (!has(C.v.pelny) && !has(C.v.sredni) && singles.length) {
      html += '<label class="owk-check"><input type="checkbox" data-toggle="gratis"' + (has(C.v.gratis) ? ' checked' : '') + '><img src="' + C.img.gratis + '&width=80" alt="">Tak, dodaj ściągawkę na lodówkę GRATIS</label>';
    }
    // stopka: kod (w treści), podsumowanie, zgoda, kasa
    var applied = (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code.toUpperCase(); });
    var ownHtml = '';
    var bar = '';
    if (promoLive()) {
      bar = applied.indexOf(C.code) > -1
        ? '<div class="owk-codebar is-ok"><span>Kod <b>' + C.code + '</b> aktywny ✓ (−' + C.pct + '%)</span></div>'
        : '<div class="owk-codebar"><span>Masz kod <b>' + C.code + '</b>: −' + C.pct + '% na całe zamówienie</span><button data-code-apply>Dodaj kod</button></div>';
    }
    ownHtml = '<details class="owk-own"><summary>Masz inny kod rabatowy?</summary><form data-own><input name="c" placeholder="Wpisz kod" autocomplete="off"><button>Dodaj</button></form><div class="err" data-own-err></div></details>';
    var omni = '';
    if (c.total_discount > 0) {
      omni = '<span class="omni">Najniższa cena z 30 dni przed obniżką: ' + c.items.filter(function (it) { return it.original_price > 0; })
        .map(function (it) { return it.product_title.split(' – ')[0] + ' – ' + money(it.original_price); }).join('; ') + '.</span>';
    }
    var breakdown = c.total_discount > 0 ? '<div class="owk-sum"><div><span>Wartość</span><span>' + money(c.original_total_price) + '</span></div><div class="save"><span>Rabat</span><span>−' + money(c.total_discount) + '</span></div></div>' : '';
    var sum = '<div class="owk-sum"><div class="tot"><span>Do zapłaty' + (c.total_discount > 0 ? ' <small>(rabat −' + money(c.total_discount) + ')</small>' : '') + '</span><span>' + money(c.total_price) + '</span></div>' + omni + '</div>';
    var cons = '<label class="owk-consent" data-consent><input type="checkbox" data-consent-input' + (consentChecked() ? ' checked' : '') + '><span>' + C.consentHtml + '</span></label><p class="owk-consent__err">Zaznacz zgodę, żeby przejść do płatności.</p>';
    body.innerHTML = html + bar + ownHtml + breakdown +
      '<div class="owk-pay"><span class="blik">BLIK</span><span>Apple Pay</span><span>Google Pay</span><span>VISA</span><span>Mastercard</span></div>' +
      '<p class="owk-mini">PDF na maila od razu po płatności · bezpieczne płatności</p>';
    foot.innerHTML = sum + cons +
      '<button class="owk-btn" data-checkout>Przejdź do kasy · ' + money(c.total_price) + '</button>';
  }

  function renderCheckoutBtn() {
    $$('[data-checkout]').forEach(function (b) { b.classList.toggle('is-disabled', !consentChecked()); });
  }

  function checkout(btn) {
    var foot = btn.closest('[data-cart-foot]') || btn.closest('[data-buybox]') || document;
    if (!requireConsent(foot)) return;
    btn.classList.add('is-loading');
    var body = { attributes: consentAttrs() };
    if (codeActive()) body.discount = C.code;
    post('/cart/update.js', body).then(function () { location.href = '/checkout'; });
  }

  /* ---------- zdarzenia ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-buy-now],[data-add],[data-rm],[data-swap],[data-code-activate],[data-code-apply],[data-checkout],[data-cart-open],[data-cart-close],[data-copy-code],[data-zoom],.owk-lb');
    if (!t) return;
    if (t.hasAttribute('data-buy-now')) { e.preventDefault(); buyNow(parseInt(t.getAttribute('data-buy-now'), 10), t); }
    else if (t.hasAttribute('data-add')) { e.preventDefault(); t.classList.add('is-loading'); addToCart(parseInt(t.getAttribute('data-add'), 10)).then(function () { t.classList.remove('is-loading'); }); }
    else if (t.hasAttribute('data-rm')) { var m = {}; m[t.getAttribute('data-rm')] = 0; setQty(m); }
    else if (t.hasAttribute('data-swap')) {
      var u = {}; cart.items.forEach(function (it) { if (C.single.indexOf(it.variant_id) > -1 || it.variant_id === C.v.sredni || it.variant_id === C.v.gratis) u[it.variant_id] = 0; });
      u[C.v.pelny] = 1; t.classList.add('is-loading'); setQty(u);
    }
    else if (t.hasAttribute('data-code-activate') || t.hasAttribute('data-code-apply') || t.hasAttribute('data-copy-code')) { e.preventDefault(); activateCode(); if (t.hasAttribute('data-copy-code')) t.textContent = 'Skopiowano ✓'; }
    else if (t.hasAttribute('data-checkout')) { e.preventDefault(); checkout(t); }
    else if (t.hasAttribute('data-cart-open')) { e.preventDefault(); refresh(); open(); }
    else if (t.hasAttribute('data-cart-close')) { close(); }
    else if (t.hasAttribute('data-zoom')) { var lb = $('.owk-lb'); $('img', lb).src = t.getAttribute('data-zoom'); lb.classList.add('is-open'); }
    else if (t.classList.contains('owk-lb')) { t.classList.remove('is-open'); }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-consent-input')) {
      SS.set('owk_consent', t.checked ? '1' : '0'); syncConsent();
      $$('[data-consent]').forEach(function (b) { b.classList.remove('is-error'); });
    }
    if (t.hasAttribute('data-toggle')) {
      var v = C.v[t.getAttribute('data-toggle')];
      if (t.checked) addToCart(v, true); else { var m = {}; m[v] = 0; setQty(m); }
    }
  });
  document.addEventListener('submit', function (e) {
    if (!e.target.hasAttribute('data-own')) return;
    e.preventDefault();
    var code = (e.target.c.value || '').trim(); if (!code) return;
    var codes = (cart.discount_codes || []).map(function (d) { return d.code; }); codes.push(code);
    post('/cart/update.js', { discount: codes.join(',') }).then(refresh).then(function (c) {
      var ok = (c.discount_codes || []).some(function (d) { return d.code.toUpperCase() === code.toUpperCase() && d.applicable; });
      var err = $('[data-own-err]'); if (err && !ok) err.textContent = 'Ten kod nie działa w tym koszyku.';
    });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* ---------- sticky bar ---------- */
  function sticky() {
    var bar = $('[data-sticky]'), hero = $('[data-hero-buy]'), offer = $('[data-offer]');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    var heroVis = true, offerVis = false;
    var upd = function () { bar.classList.toggle('is-on', !heroVis && !offerVis); };
    new IntersectionObserver(function (en) { heroVis = en[0].isIntersecting; upd(); }).observe(hero);
    if (offer) new IntersectionObserver(function (en) { offerVis = en[0].isIntersecting; upd(); }).observe(offer);
  }

  document.addEventListener('DOMContentLoaded', function () {
    drawer = $('.owk-drawer'); overlay = $('.owk-ov');
    $$('a[href="/cart"]').forEach(function (a) { a.setAttribute('data-cart-open', ''); });
    if (overlay) overlay.addEventListener('click', close);
    if (new URLSearchParams(location.search).get('discount') === C.code) SS.set('owk_code', '1');
    tick(); setInterval(tick, 1000);
    renderCode(); syncConsent(); sticky();
    if (drawer) refresh();
  });
})();
